import {create} from 'zustand';
import {createJSONStorage, persist} from 'zustand/middleware';

interface CookieState {
  all: boolean;
  necessary: boolean;
  isOpen: boolean;
  handleClose: () => void;
  acceptAll: () => void;
  acceptNecessary: () => void;
}

export const useCookieStore = create<CookieState>()(
  persist(
    (set) => ({
      isOpen: true,
      all: false,
      necessary: false,
      acceptAll: () => set({all: true}),
      acceptNecessary: () => set({necessary: true}),
      handleClose: () => set(() => ({isOpen: false})),
    }),

    {
      name: 'cookie-storage',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
